import React from 'react';
import s from './index.module.less';

const RechargeGuideModal = ({ open, onClose, onRecharge, compact = false }) => {
  if (!open) return null;

  return (
    <div className={s.mask} role="dialog" aria-modal="true" aria-label="补充算力">
      <div className={`${s.modal} ${compact ? s.compact : ''}`}>
        {!compact && <button className={s.close} type="button" aria-label="关闭" onClick={onClose}>×</button>}
        {compact && <button className={s.compactClose} type="button" aria-label="关闭" onClick={onClose} />}
        <div className={s.content}>
          <button className={s.recharge} type="button" onClick={onRecharge}>立即充值算力</button>
          <button className={s.later} type="button" onClick={onClose}>稍后再说，继续体验</button>
        </div>
      </div>
    </div>
  );
};

export default RechargeGuideModal;
